import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateIncomingCount',
})
export class TranslateIncomingCountPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(count: number): string {
    if (!count) {
      return '';
    }
    const message: string =
      count === 1
        ? this.translateService.instant('+INSTALLATIONS.INSTALLATIONS.INCOMING_INVITATION_COUNT')
        : this.translateService.instant('+INSTALLATIONS.INSTALLATIONS.INCOMING_INVITATIONS_COUNT');

    return message.replace('{{count}}', `${count}`);
  }
}
